import {
  ResolutionDetailsPreview,
  ResolutionDetailsProcess,
  ResolutionDetailsSummary
} from '@bo-components/resolutions/resolutionDetails';
import type { ResolutionStepperIdx } from '@library/types/resolutions/resolutionDetails';

export interface ResolutionDetailsStepsProps {
  currentResolutionStep: ResolutionStepperIdx;
}
export const ResolutionDetailsSteps = ({
  currentResolutionStep
}: ResolutionDetailsStepsProps) => {
  if (currentResolutionStep === 3) {
    return <ResolutionDetailsPreview />;
  }

  if (currentResolutionStep === 4) {
    return <ResolutionDetailsProcess />;
  }

  if (currentResolutionStep === 5) {
    return <ResolutionDetailsSummary />;
  }
  return null;
};
